import React from 'react';
import ReactDOM from 'react-dom';
import CircularLoader from './components/CircularLoader';

interface CustomLoaderProps {
    isLoading?: boolean;
    advanced?: boolean;
}

const CustomLoader: React.FC<CustomLoaderProps> = ({
	isLoading,
	advanced = false,
}) => {
	const portalContainer = document.getElementById('loader-container');

	if (!isLoading || !portalContainer || isLoading === undefined) {
		return null;
	}

	return ReactDOM.createPortal(
		<div
			style={{
				position: 'fixed',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				zIndex: 13000,
			}}
		>
			<CircularLoader
				advanced={advanced}
			/>
		</div>,
		portalContainer,
	);
};

export default CustomLoader;